import { CircularProgress as MuiCircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import percentService from '../../services/percent';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ palette }) => ({
    root: {
      position: 'relative',
      display: 'inline-block',
    },
    progress: {
      color: palette.status.inProgress,
      strokeLinecap: 'round',
      position: 'relative',
    },
    circle: {
      color: palette.divider,
      position: 'absolute',
      border: 'none',
    },
  }),
  { classNamePrefix: 'CircularLearningProgress' }
);

const MIN_DISPLAYABLE_VALUE = 1;
const MAX_DISPLAYABLE_VALUE = 94;

/**
 * @deprecated
 * ### Description
 * `CircularLearningProgress` has been deprecated and replaced by Classify `CircularLearningProgress`.
 *
 * ### Example
 * ```
 * import CircularLearningProgress from '@classify/react-product-components/CircularLearningProgress';
 * ```
 */
function CircularLearningProgress({ value, maxValue, size = 30, ariaHidden = 'false', ...props }) {
  const percent = Math.min(
    Math.max(percentService.getPercent(value, maxValue), MIN_DISPLAYABLE_VALUE),
    MAX_DISPLAYABLE_VALUE
  );

  const progressProps =
    percent === MAX_DISPLAYABLE_VALUE
      ? {
          style: { transform: 'rotate(-80deg)' },
        }
      : {};

  const classes = useStyles(props);

  if (value === maxValue) {
    return null;
  }

  return (
    <div className={classes.root} style={{ height: size, width: size }} aria-hidden={ariaHidden}>
      <MuiCircularProgress
        className={classes.circle}
        variant="determinate"
        value={100}
        size={size}
        thickness={6}
      />
      <MuiCircularProgress
        className={classes.progress}
        variant="determinate"
        value={percent}
        size={size}
        thickness={6}
        {...progressProps}
      />
    </div>
  );
}

export default CircularLearningProgress;
